import { reactive } from '@vue/reactivity'

const stores = {}

export function store(key = null, value = null) {

    if (!key) {
        return stores
    }

    if (value) {
        stores[ key ] = reactive(value)
    } else {
        return stores[ key ] || null
    }

}
